export const buildTableSettingsColumns = (columns) => {
  const settings = [];
  // eslint-disable-next-line no-restricted-syntax,no-unused-vars
  for (const [groupIndex, group] of columns.entries()) {
    settings.push({
      name: group.SettingsHeader || group.Header,
      order: [],
    });
    // eslint-disable-next-line no-restricted-syntax,no-unused-vars
    for (const child of group.columns) {
      settings[groupIndex].order.push({
        name: child.SettingsHeader || child.Header,
        id: child.id,
        visible: child.visible === undefined ? true : child.visible,
      });
    }
  }
  return settings;
};
